module.exports = __webpack_public_path__ + "img/image-thumb-18.bf1c6c57.jpg";